import { render, staticRenderFns } from "./AppointmentRestrictions.vue?vue&type=template&id=9598fd3a&scoped=true&"
import script from "./AppointmentRestrictions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AppointmentRestrictions.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AppointmentRestrictions.vue?vue&type=style&index=0&id=9598fd3a&lang=scss&"
import style1 from "./AppointmentRestrictions.vue?vue&type=style&index=1&id=9598fd3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9598fd3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9598fd3a')) {
      api.createRecord('9598fd3a', component.options)
    } else {
      api.reload('9598fd3a', component.options)
    }
    module.hot.accept("./AppointmentRestrictions.vue?vue&type=template&id=9598fd3a&scoped=true&", function () {
      api.rerender('9598fd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentRestrictions/AppointmentRestrictions.vue"
export default component.exports